import React, { useEffect, useState } from "react";
import "./Style.css";
import Layout from "../../Components/Layout/Layout";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import placeholder from "../../Assets/atlastrainingthumbnail.jpg";
import document from "../../Assets/doc-icon.svg";
import {
  ATLAS_VIDEO_LINKS,
  ATLAS_CHATTING_BASICS_JOB_AID,
  ATLAS_DEEP_INSIGHTS_JOB_AID,
  ATLAS_FEEDBACK_JOB_AID,
} from "../../Utils/Constants";

const AtlasTraining = () => {
  const [atlasVideo, setAtlasVideo] = useState();
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);

  const openVideoModal = (item) => {
    setAtlasVideo(item);
    setVideoOpen(true);
  };

  const handleCloseVideo = () => setVideoOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #ffffff",
    boxShadow: 24,
    p: 4,
  };

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const cardChattingBasics = (
    <div className="cards-inner-jt">
      <p className="title-card-jt">Chatting Basics</p>
      <p className="joi-training-vdo">
        <img src={placeholder} alt="" className="joi_tr_bd" onClick={() => openVideoModal("ATLAS_CHATTING_BASICS_VIDEO")} />
      </p>
      <p className="description-cards-jt">
        Learn how to send messages, continue a conversation, and start a new chat in{" "}
        <span className="text-red-jt">Atlas Chat</span> — plus an important tip about saving your work before you go.
      </p>
      <p className="vd-title-jt"> Video Length: 1:54</p>
      <div className="doc-icon-text">
        <img src={document} alt="" />
        <a className="video-lenght-jt" href={ATLAS_CHATTING_BASICS_JOB_AID} download rel="noopener noreferrer">Download Job Aid</a>
      </div>
    </div>
  );

  const cardDeepInsights = (
    <div className="cards-inner-jt">
      <p className="title-card-jt">Deep Insights Mode</p>
      <p className="joi-training-vdo">
        <img src={placeholder} alt="" className="joi_tr_bd" onClick={() => openVideoModal("ATLAS_DEEP_INSIGHTS_VIDEO")} />
      </p>
      <p className="description-cards-jt">
        Discover how to activate{" "}
        <span className="text-red-jt">Deep Insights Mode</span> for complex research requests, track your report's progress in real time, and download the finished report to your device.
      </p>
      <p className="vd-title-jt"> Video Length: 1:48</p>
      <div className="doc-icon-text">
        <img src={document} alt="" />
        <a className="video-lenght-jt" href={ATLAS_DEEP_INSIGHTS_JOB_AID} download rel="noopener noreferrer">Download Job Aid</a>
      </div>
    </div>
  );

  const cardFeedback = (
    <div className="cards-inner-jt">
      <p className="title-card-jt">Providing Feedback</p>
      <p className="joi-training-vdo">
        <img src={placeholder} alt="" className="joi_tr_bd" onClick={() => openVideoModal("ATLAS_PROVIDING_FEEDBACK_VIDEO")} />
      </p>
      <p className="description-cards-jt">
        Find out how to submit feedback directly within{" "}
        <span className="text-red-jt">Atlas Chat</span> to report inaccurate results, flag missing information, or share suggestions that help improve the tool for everyone.
      </p>
      <p className="vd-title-jt"> Video Length: 1:11</p>
      <div className="doc-icon-text">
        <img src={document} alt="" />
        <a className="video-lenght-jt" href={ATLAS_FEEDBACK_JOB_AID} download rel="noopener noreferrer">Download Job Aid</a>
      </div>
    </div>
  );

  return (
    <>
      <Layout>
        {isPortrait ? (
          /* Portrait: 2 cards per row */
          <div>
            <div className="main-joi-cards-jt">
              <div className="outer-card-jt">
                {isMobile ? (
                  <p style={{ fontFamily: "Inter", fontWeight: "700", fontStyle: "Bold", fontSize: "18px", paddingBottom: "10px" }}>
                    Atlas Training
                  </p>
                ) : ""}
                {cardChattingBasics}
              </div>
              <div className="outer-card-jt">{cardDeepInsights}</div>
            </div>
            <div className="main-joi-cards-jt">
              <div className="outer-card-jt">{cardFeedback}</div>
            </div>
          </div>
        ) : (
          /* Landscape: 3 cards per row (matches JOI Training) */
          <div>
            <div className="main-joi-cards-jt">
              <div className="outer-card-jt">
                {isMobile ? (
                  <p style={{ fontFamily: "Inter", fontWeight: "700", fontStyle: "Bold", fontSize: "18px", paddingBottom: "10px" }}>
                    Atlas Training
                  </p>
                ) : ""}
                {cardChattingBasics}
              </div>
              <div className="outer-card-jt">{cardDeepInsights}</div>
              <div className="outer-card-jt">{cardFeedback}</div>
            </div>
          </div>
        )}

        <Modal
          open={videoOpen}
          onClose={handleCloseVideo}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="modal-joiTraining-videos"
        >
          <Box sx={style} className="box-video-modals">
            <div className="box-section-relative">
              <div className="cross-icon-section" onClick={handleCloseVideo}>
                <CloseIcon />
              </div>
              <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
                <iframe
                  src={ATLAS_VIDEO_LINKS[atlasVideo]}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                  }}
                  title="Atlas Training"
                ></iframe>
              </div>
            </div>
          </Box>
        </Modal>
      </Layout>
    </>
  );
};

export default AtlasTraining;
